module.exports = __webpack_public_path__ + "img/us-bg.ffffe5d8.png";